export const glFooter = ['$window', function($window){
    return {
        link: function(scope, elem, attrs) {
            let win = angular.element($window);
            let adjustedFooter = attrs.glFooter;
            function adjustFooterPos() {
                let footerHeight = elem.prop('offsetHeight');
                let homeBlog = angular.element('.tp-FrontPage_BlogWrap');
                let prevElem = angular.element(homeBlog.prop('previousElementSibling'));
                console.log(homeBlog);
                // elem.css('margin-top', -footerHeight);
                if (homeBlog) {
                    homeBlog.height(win.height() - footerHeight - prevElem.outerHeight());
                }
            }
            if (adjustedFooter && win.width() >= 800) {
                adjustFooterPos();
            }
            if (adjustedFooter) {
                win.bind('resize', function() {
                    if (adjustedFooter && win.width() >= 800 ) {
                        adjustFooterPos();
                        scope.$apply();
                    } else {
                        elem.removeAttr('style');
                        homeBlog.removeAttr('style');
                    }
                });
            }
        }
    }
}];